<template>
    <div class="post__aside-card p-0">
        <div class="post__tabs-heading">
            <ul class="list-unstyled d-flex post__tabs">
                <li
                    class="post__tabs-item"
                    :class="{'post__tabs-item--active': activeTab === tab.value}"
                    v-for="tab in this.tabs"
                    :key="tab.value"
                    @click="activeTab = tab.value"
                >
                    {{ tab.label }}
                </li>
            </ul>
        </div>
        <div class="post__tabs-content pb-3">
            <transition name="fade" mode="out-in">
                <keep-alive>
                    <component
                        :is="activeTabContent"
                        v-bind="bindComponentProps()"
                    />
                </keep-alive>
            </transition>
        </div>
    </div>
</template>

<script>
import PostUser from "./PostUser";
import PostPet from "./PostPet";

// const tabs = [
//     {label: this.$store.getters.t('blog_post_tabs_pet'), value: "pet"},
//     {label: this.$store.getters.t('blog_post_tabs_author'), value: "user"},
// ];

const componentsMap = {
    user: PostUser,
    pet: PostPet,
};

export default {
    name: "PostUserTabs",
    components: {PostUser, PostPet},
    props: {
        user: {required: true, type: Object},
        pet: {required: true, type: Object},
    },

    data() {
        return {
            activeTab: "pet",
        };
    },

    computed: {
        tabs() {
            return [
                {label: this.$store.getters.t('blog_post_tabs_pet'), value: "pet"},
                {label: this.$store.getters.t('blog_post_tabs_author'), value: "user"},
            ]
        },
        activeTabContent() {
            return componentsMap[this.activeTab];
        }
    },
    test: 'this',
    methods: {
        bindComponentProps() {
            return this.activeTab === 'pet' ?
                {
                    pet: this.pet
                }
                : {
                    user: this.user,
                    withHeading: false,
                }
        }
    },
};
</script>
